import { Container, Row, Col, NavItem, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { toast } from 'react-toastify';
import { Button, Box, Card, IconButton, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab, Tooltip } from '@mui/material';
import { authKey, GET_DASAHBOARD_CONSIGNMENT_LIST } from '../../../common/URLs';
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { Fab } from '@mui/material';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { ClickHereIcon } from '../../../common/icons';
import apiClient from '../../../axios';

function Intransit() {
  const navigate = useNavigate();

  useEffect(() => {
    if (getLocalStorageItem('id_token')) {

      loadConsignmentData()
      //getIneventoryDashBoard();
    }
  }, []);

  const [rows, setRows] = useState([]);


  const consignmentDetails = (consignment) => {
    if (consignment?.materialType === "RawBamboo") {
      navigate("/inventoryDashboard/inTransit/Lletracker", {
        state: { selectedConsNo: consignment?.consignmentNo }
      });
    }
    else {
      navigate("/inventoryDashboard/inTransit/LlePickUpDetails", {
        state: { selectedConsNo: consignment?.consignmentNo }
      });
    }
  }

  const columns = [

    { field: 'consignmentNo', headerName: 'Intransit', width: 150 },

    { field: 'consignmentSourceUrn', headerName: 'Intransit Owner Urn', width: 200 },

    { field: 'consignmentOwnerName', headerName: 'Intransit Owner Name', width: 200 },

    { field: 'consignmentOwnerContactNo', headerName: 'Intransit Owner Contact', width: 170 },

    { field: 'consignmentWeight', headerName: 'Weight', width: 120 },

    {

      field: 'View Details', width: 130,

      renderCell: (cellValues) => {

        return (
          <Tooltip title="Click Here">
            <IconButton
              variant="contained"
              color="primary"
              onClick={() => consignmentDetails(cellValues.row)}
            >
              <ClickHereIcon />
            </IconButton>
          </Tooltip>
        );

      }

    },

  ];


  const loadConsignmentData = () => {
    //setCardSelected(consignmentStatus);
    apiClient
      .post(GET_DASAHBOARD_CONSIGNMENT_LIST,
        {
          "consignmentType": "HIT",
          "consignmentStatus": "InTransit"
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        console.log(response?.data?.consignments);
        setRows(response?.data?.consignments);
      })
      .catch(function (error) {
        console.log(error);
        toast.error(error.message);
      });
  }




  return (





    <Container fluid>


      <br></br>

      {/* <Row>
          
  
          <Col xs={12} md={4}>
            <div className="card-tr">
              <div style={{cursor: "pointer",textDecoration:"underline", color: '#005BAA',float:"right", marginRight: '1vw', marginTop: '0vh' }}>Click to view list </div>
              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{}</Typography>
              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>To be Loaded</Typography>
            </div>
          </Col>
          <Col xs={12} md={4}>
            <div className="card-tr">
             <div  style={{cursor: "pointer",textDecoration:"underline", color: '#005BAA', float:"right",marginRight: '1vw', marginTop: '0vh' }}>Click to view list </div>
              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{}</Typography>
              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>In-transit</Typography>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <div className="card-tr">
              <div style={{ cursor: "pointer",textDecoration:"underline",color: '#005BAA', float:"right",marginRight: '1vw', marginTop: '0vh', }}>Click to view list</div>
              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{}</Typography>
              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>Unloaded</Typography>
            </div>
          </Col>
          <Col xs={12} md={4}>
            <div className="card-tr">
              <div style={{cursor: "pointer",textDecoration:"underline", color: '#005BAA',float:"right", marginRight: '1vw', marginTop: '0vh',  }}>Click to view list </div>
              <Typography style={{ fontWeight: 800, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '1vh' }}>{}</Typography>
              <Typography style={{ fontWeight: 500, color: '#000000', fontSize: '1rem', textAlign: 'left', marginTop: '4vh' }}>GRN Complete</Typography>
            </div>
          </Col>
  
          <br></br>
          <br></br>
  
  
        </Row>
   */}

      <Typography variant="h4" sx={{ mb: 2 }}>
        <Fab onClick={() => { navigate(-1) }} size="small" aria-label="back" title='Back'>
          <KeyboardArrowLeftRounded />
        </Fab>
      </Typography>
      <Card>
        <Box style={{ height: 350, width: '100%' }}>
          <DataGrid rows={rows}
            columns={columns}
            pageSize={10}
          />
        </Box>
      </Card>
    </Container>
  )
}

export default Intransit;





